import React from 'react';
import { Link } from 'react-router';
import { useCurrentTracklog, useDebriefRouter } from 'ff/debrief/hooks';

interface Props {
    tracklogId?: string;
    onClick?: () => void;
}

const LinkToDebrief = React.forwardRef<
    HTMLAnchorElement,
    React.PropsWithChildren<Props>
>(function LinkToDebrief(props, ref) {
    const { tracklogId, ...rest } = props;
    const { tracklog } = useCurrentTracklog();
    const { getDebriefRouteString } = useDebriefRouter();
    const isFromShared = location.pathname.includes('/shared');
    const pathString = getDebriefRouteString(tracklogId || tracklog?.trackUuid);
    if (pathString)
        return (
            <Link ref={ref} to={pathString} state={{ isFromShared }} {...rest}>
                {props.children}
            </Link>
        );
    else return null;
});

export default LinkToDebrief;
